import React, { useState, useRef, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from "react-router-dom";

export default function TravelMenu(props) {
    return (

        <div className={`container`} style={{ backgroundColor: "var(--backgroundcolor)", color: "var(--backgroundcolor)", paddingTop: '110px' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Link to="/">
                                <img src="/img/3-icon.png" alt="" height="80"/>
                            </Link>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Typography component="p" style={{ color: "var(--darker)", fontWeight:'bold', borderBottom: (props.activeIndex === 1 ? '3px solid var(--color-primary,#01A05A)' : 'none') }}>Flights</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Link to="/hotels">
                                <img src="/img/2-icon.png" alt="" height="80"/>
                            </Link>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Typography component="p" style={{ color: "var(--darker)", fontWeight:'bold', borderBottom:  (props.activeIndex === 2 ? '3px solid var(--color-primary,#01A05A)' : 'none') }}>Hotels</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Link to="/">
                                <img src="/img/1-ico.png" alt="" height="80"/>
                            </Link>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Typography component="p" style={{ color: "var(--darker)", fontWeight:'bold' }}>Insurance</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <hr></hr>
        </div>
    )


}